import React from "react";
import i18n from "../../../i18n";
import { HTMLTable, Spinner, Tag } from "@blueprintjs/core";

import { authenticatedGetFetch } from "../../../utils/AuthenticatedFetch";
import PieChart from "../../Charts/PieChart";
import { Trans } from "react-i18next";
import { generic_colors } from "../../Charts/Colors";
import { mefMontant } from "../../../utils/mef";

export default class PieMeansOfPayment extends React.Component {
  constructor() {
    super();
    this.state = {
      data: [],
      labels: [],
      loading: false,
    };
  }

  ac = new AbortController();

  componentDidMount() {
    if (this.props.urlsearchparams !== undefined) {
      this.setState({ loading: true }, () => {
        authenticatedGetFetch(
          "/financial/mopRepartition?" + this.props.urlsearchparams,
          (res) => {
            this.setState({
              data: res["data"],
              labels: res["labels"],
              loading: false,
            });
          },
          null,
          this.ac.signal
        );
      });
    }
  }

  componentWillUnmount() {
    this.ac.abort();
  }

  render() {
    let sum = 0;
    const lines = [];
    for (let i = 0; i < (this.state.data || []).length; i++)
      sum += this.state.data[i];

    for (let i = 0; i < (this.state.data || []).length; i++)
      lines.push(
        <tr>
          <td>
            <Tag style={{ backgroundColor: generic_colors[i], color: "black" }}>
              <Trans>{this.state.labels[i] || "unknown"}</Trans>
            </Tag>
          </td>
          <td>{mefMontant(this.state.data[i] * 100)}</td>
          <td>{Math.round((this.state.data[i] / sum) * 100)}%</td>
        </tr>
      );

    return this.state.loading ||
      this.state.data === undefined ||
      this.state.data === undefined ? (
      <Spinner />
    ) : this.state.data.length > 0 ? (
      <div>
        <PieChart
          data={this.state.data}
          labels={this.state.labels}
          title={i18n.t("distribution of payment method")}
          fixedLabels={true}
          unit="€"
        />
        <HTMLTable striped={true} compact={true}>
          <thead>
            <tr>
              <th>
                <Trans>means of payment</Trans>
              </th>
              <th>
                <Trans>recette</Trans>
              </th>
              <th>%</th>
            </tr>
          </thead>
          <tbody>{lines}</tbody>
        </HTMLTable>
      </div>
    ) : (
      ""
    );
  }
}
